import i18next from 'i18next'
import { OptionType } from 'src/types/menu'
import { v4 as uuid } from 'uuid'

import { ROUTES } from '../constants'

export const getSidebarDefaultOptions = (isAdmin: boolean): OptionType[] => {
  const isDev = process.env.NODE_ENV === 'development'

  return [
    ...(isAdmin
      ? [
          {
            id: uuid(),
            title: i18next.t('sidebar.links.uiConfigs'),
            code: 'ui_configs',
            viewCode: '',
            hasChild: true,
            childrenMenu: [
              {
                id: uuid(),
                title: i18next.t('sidebar.links.contexts'),
                code: 'contexts',
                viewCode: ROUTES.CONFIG_CONTEXTS,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.contextMenu'),
                code: 'context_menu',
                viewCode: ROUTES.CONFIG_CONTEXT_MENU,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.controlPanels'),
                code: 'control_panels',
                viewCode: ROUTES.CONFIG_CONTROL_PANELS,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.views'),
                code: 'views',
                viewCode: ROUTES.CONFIG_VIEWS,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.ganttChart'),
                code: 'gantt',
                viewCode: ROUTES.CONFIG_GANTT,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.forms'),
                code: 'forms',
                viewCode: ROUTES.CONFIG_FORMS,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.diagrams'),
                code: 'diagrams',
                viewCode: ROUTES.DIAGRAMS,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.maps'),
                code: 'maps',
                viewCode: ROUTES.MAPS,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.timeLines'),
                code: 'timelines',
                viewCode: ROUTES.TIME_LINE_GRID,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.listControls'),
                code: 'list_controls',
                viewCode: ROUTES.CONFIG_LIST_CONTROLS,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.dropdownEntities'),
                code: 'dropdown_entities',
                viewCode: ROUTES.CONFIG_DROP_DOWN_ENTITY,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.dictionary'),
                code: 'dictionary',
                viewCode: ROUTES.DICTIONARY,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.searchAssistants'),
                code: 'search_assistants',
                viewCode: ROUTES.CONFIG_SEARCH_ASSISTANTS,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.variables'),
                code: 'variables',
                viewCode: ROUTES.VARIABLES,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.tooltips'),
                code: 'tooltips',
                viewCode: ROUTES.CONFIG_TOOLTIPS,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.windows'),
                code: 'windows',
                viewCode: ROUTES.CONFIG_WINDOWS,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.parameters'),
                code: 'parameters',
                viewCode: ROUTES.PARAMETERS,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.styleSettings'),
                code: 'style_settings',
                viewCode: ROUTES.CONFIG_STYLE_SETTINGS,
                hasChild: false,
                childrenMenu: [],
              },
              {
                id: uuid(),
                title: i18next.t('sidebar.links.displayRules'),
                code: 'display_rules',
                viewCode: ROUTES.CONFIG_DISPLAY_RULES,
                hasChild: false,
                childrenMenu: [],
              },
            ],
          },
        ]
      : []),
  ]
}
